import clsx from 'clsx';

export type ResourceHeaderProps = {
  suffix?: React.ReactNode;
  name: string;
  className?: string;
};

export function ResourceHeader(props: ResourceHeaderProps) {
  const { suffix, className, name } = props;

  return (
    <div className={clsx('flex items-center', className)}>
      <h1 className="text-[32px] font-600 leading-10 text-color" title={name}>
        {name}
      </h1>

      {suffix && <div className="flex-shrink-0">{suffix}</div>}
    </div>
  );
}
